import ClearTripLogo from '@/src/assets/png/ClearTripLogo.png'
import FlyinLogo from '@/src/assets/svgs/FlyinLogo'
import { VARIANT } from '@/src/utils/buildUtils'
import Image from 'next/image'

const BrandLogo = () => {
    const variant = VARIANT
    switch (variant) {
        case 'FLYIN':
            return <FlyinLogo sx={{ width: 62, height: 26 }} />
        case 'CLEARTRIP':
            return <Image src={ClearTripLogo} alt="Cleartrip.com" width={100} height={22} />
        default:
            return <FlyinLogo sx={{ width: 62, height: 26 }} />
    }
}

export default BrandLogo
